import React from "react";
import { Container, Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import Loading from "../../shared/components/Loading/Loading";
import { useBlingSettings } from "./hooks/useBlingSettings";
import BlingConnectionPanel from "./components/BlingConnectionPanel";
import BlingFiscalForm from "./components/BlingFiscalForm";
import BlingProductSyncPanel from "./components/BlingProductSyncPanel";
import "./BlingIntegrationPage.css";

const BlingIntegrationPage = () => {
  const { status, config, naturezas, loading, saving, error, save, reload } =
    useBlingSettings();

  const handleSave = async (changes) => {
    if (await save(changes))
      toast.success("Configuração do Bling salva.", { autoClose: 3000 });
  };

  return (
    <div className="site-content">
      <div className="content-wrapper pt-6 pb-6">
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h3 className="mb-0">Bling</h3>
              <p className="text-muted mb-0">
                Produtos, clientes e emissão automática de NF-e
              </p>
            </Col>
          </Row>

          {status && status.live === false && (
            <div className="alert alert-warning" role="status">
              <strong>Homologação:</strong> o Bling fica desativado aqui.
              Pedidos pagos recebem uma <strong>NF-e de teste</strong> (sem
              valor fiscal, nada vai ao Bling nem à SEFAZ) para testar o fluxo
              até o Melhor Envio. A integração real funciona só em produção.
            </div>
          )}

          {error && <div className="alert alert-danger">{error}</div>}

          <Row>
            <Col lg={6} className="mb-4">
              <BlingConnectionPanel status={status} onReload={reload} />
            </Col>
            <Col lg={6} className="mb-4">
              <BlingProductSyncPanel
                disabled={!status?.live || !status?.connected}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={8}>
              <BlingFiscalForm
                config={config}
                naturezas={naturezas}
                saving={saving}
                onSave={handleSave}
              />
            </Col>
          </Row>
        </Container>
      </div>
      {loading && <Loading overlay />}
    </div>
  );
};

export default BlingIntegrationPage;
